/* istanbul ignore file */
import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center", 
    alignContent: "center",
    marginBottom: "200px"
  },
});
function HomePage({ userType } : { userType: string | null | undefined}) {
  const classes = useStyles();
  return (
    <Box className={classes.main}>
    </Box>
  );
}

export default HomePage;
